import './Hero.css'
import HeroLogo from './HeroLogo'
import HeroTitle from './HeroTitle'
import HeroAuth from './HeroAuth'
import HeroSubtitle from './HeroSubtitle'
import HeroDownloadButton from './HeroDownloadButton'
import HeroRequirements from './HeroRequirements'

const Hero = ({ user, onAuthClick, onAccountClick }) => {
  return (
    <section className="hero" id="home">
      <div className="hero__container">
        {/* Logo - Left Side */}
        <HeroLogo />

        {/* Content - Center */}
        <div className="hero__content">
          {/* Title row with login on right */}
          <div className="hero__title-row">
            {/* Main Title with medieval style */}
            <HeroTitle />

            {/* Login Button - Right of title */}
            <HeroAuth user={user} onAuthClick={onAuthClick} onAccountClick={onAccountClick} />
          </div>

          <HeroSubtitle />

          {/* Download Button - Big and Medieval */}
          <HeroDownloadButton />

          {/* Requirements - Below Download */}
          <HeroRequirements />
        </div>
      </div>
    </section>
  )
}

export default Hero
